import { useQuery } from '@tanstack/react-query';

import { QueryKey } from '@/types/query';
import { type AddressAutocompleteMode, toAddressViewModel } from '../model';
import { addressClient } from './client';

export const useGetAddressQuery = ({ search, mode }: { search: string; mode?: AddressAutocompleteMode }) => {
  return useQuery({
    queryKey: [QueryKey.useGetAddressQuery, search, mode ?? null],
    queryFn: async () => {
      const { data } = await addressClient.getAddress({ search, mode });

      return toAddressViewModel(data);
    },
    enabled: search.length > 0,
  });
};
